// src/app/core/mainPage/components/NewsCard.tsx
import { motion } from 'motion/react';
import type { NewsItem } from '@/app/core/mainPage/prompt/shared/types';

interface NewsCardProps {
  item: NewsItem;
  onClick: () => void;
}

export const NewsCard = ({ item, onClick }: NewsCardProps) => {
  const { background } = item;

  // Определяем стили фона
  let backgroundStyle: React.CSSProperties = {};
  let overlayStyle: React.CSSProperties = {};

  if (background) {
    if (background.startsWith('http')) {
      // Это изображение – применяем с блюром
      backgroundStyle = {
        backgroundImage: `url(${background})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        filter: 'blur(12px)',
        transform: 'scale(1.05)', // компенсирует белые края от блюра
      };
      overlayStyle = {
        position: 'absolute',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.3)', // затемнение для читаемости текста
        borderRadius: '1rem',
      };
    } else {
      // Сплошной цвет
      backgroundStyle = { backgroundColor: background };
    }
  }

  return (
    <motion.button
      whileHover={{ scale: 1.01, borderColor: 'var(--accent)' }}
      whileTap={{ scale: 0.99 }}
      onClick={onClick}
      className={`relative w-full p-5 rounded-2xl border transition-all text-left shadow-md overflow-hidden ${
        background ? 'border-transparent' : 'glass'
      }`}
      style={!background ? {} : { borderColor: 'transparent' }}
    >
      {/* Фоновый слой (если задан) */}
      {background && <div className="absolute inset-0 rounded-2xl" style={backgroundStyle} />}
      {/* Затемняющий оверлей для картинок */}
      {background && background.startsWith('http') && <div style={overlayStyle} />}

      {/* Контент */}
      <div className="relative z-10">
        <h3 className={`text-sm font-semibold mb-2 truncate ${background ? 'text-white' : 'text-foreground'}`}>
          {item.title}
        </h3>
        <p className={`text-xs line-clamp-2 ${background ? 'text-white/80' : 'text-foreground/80'}`}>
          {item.summary}
        </p>
      </div>
    </motion.button>
  );
};